var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"depressed":"","icon":""}},'v-btn',attrs,false),on),[(_vm.emailAddress)?_c('base-avatar',{attrs:{"email":_vm.emailAddress,"name":_vm.name || _vm.emailAddress,"size":32}}):_vm._e()],1)]}}],null,true)},[_c('v-list',{staticClass:"py-0"},[_vm._t("default")],2)],1)],1)]}}],null,true)},[_vm._v(" Account ")])}
var staticRenderFns = []

export { render, staticRenderFns }